// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@media (max-width: 1200px) {
  .reviews .box-container {
    margin: 0 auto;
  }

  .reviews .box-container .box .student h4 {
    font-size: 15px;
    padding-bottom: 1vh;
    order: 1;
  }
}

@media (max-width: 1100px) {
  .app-bar__navigation {
    z-index: 1000;
  }

  #indexOnMapContainer {
    width: 35%;
    font-size: 0.5rem;
  }

  .map-info {
    flex-direction: column;
    justify-content: start;
    align-items: start;
    border-radius: 10px;
    right: 15px;
    width: 145px;
    padding: 1rem;
    left: auto;
    transform: translateX(0%);
    bottom: 30px;
  }

  .index-info {
    font-size: 0.75rem;
    margin: 0 0 0.75rem;
  }

  .index-info .dot {
    min-width: 10px;
    min-height: 10px;
  }
}

@media (min-width: 1135px) {
}

@media (max-width: 1020px) {
  #detailContainer {
    padding: 1rem 3rem;
  }

  .aqi-chart-card {
    width: 100%;
    height: 50vw;
  }
}

@media (max-width: 1000px) {
  .blog-article {
    display: flex;
    flex-direction: column;
    gap: 0;
  }

  .article-content,
  .blog-article .recommended-articles {
    width: 100%;
  }

  .recommended-articles-container {
    display: grid;
    grid-template-columns: 1fr 1fr;
    place-items: center;
  }

  .hero .image-hero img {
    max-width: 250px;
  }
}

@media (max-width: 950px) {
  .main .hero {
    text-align: center;
    flex-direction: column-reverse;
  }
  
  .main .section-title {
    font-size: 32px;
  }

  .main .hero .content-hero {
    display: flex;
    flex-direction: column;
    justify-content: center;
    margin: auto;
  }

  .main .hero .content-hero p {
    line-height: 100%;
  }

  .main .hero .content-hero p:nth-child(1) {
    order: 2;
    font-size: 16px;
    padding-right: 0vw;
  }

  .main .hero .content-hero h2 {
    font-size: clamp(32px, 6vw, 800px);
    padding-bottom: 1vh;
    order: 1;
  }

  .main .hero p:nth-child(3) {
    order: 3;
    padding-right: 0vw;
    margin-top: 1rem;
  }

  .next-btn {
    order: 4;
    width: 100%;
  }

  .main .hero img {
    width: 33vw;
    min-width: 175px;
    max-width: 300px;
  }

  .main .main-recommended-articles {
    grid-template-columns: 1fr 1fr;
  }
}

@media (max-width: 813px) {
  .reviews .box-container {
    grid-template-columns: 1fr 1fr;
  }

  .data-source {
    width: 100%;
  }

  #detailContainer {
    padding: 1rem;
  }

  .summary-section {
    grid-template-columns: none;
  }

  .summary-side {
    grid-template-rows: none;
    grid-template-columns: repeat(2, 1fr);
  }

  .main .fun-fact .card-contain {
    grid-template-columns: repeat(2, 1fr);
  }

  .map-section {
    height: 100%;
  }

  .mySwiper {
    max-width: 35vw;
  }
}

@media (max-width: 700px) {
  .charts {
    flex-direction: column;
  }
  .aqi-chart-card {
    width: 100%;
    height: fit-content;
    justify-content: start;
  }

  .recommended-articles-container {
    grid-template-columns: 1fr;
  }

  .article-content img {
    min-height: 150px;
  }

  .detail-recommended-articles .blog-card {
    grid-template-columns: 1fr;
    grid-template-rows: 1fr 1fr;
  }

  .detail-recommended-articles .blog-card .text {
    grid-template-rows: 3fr 1fr;
  }

  .summary-section {
    grid-template-columns: none;
  }

  .main .summary {
    margin: auto 0.5em;
  }

  .main .main-recommended-articles {
    margin: 1em;
  }
}

@media (max-width: 660px) {
  .rank-section {
    grid-template-columns: none;
  }

  .blog-card {
    width: 100%;
  }

  .blog-card .text {
    grid-template-rows: 4fr 1fr;
  } 

  .main .main-recommended-articles {
    grid-template-columns: 1fr;
  }

  .summary-side {
    grid-template-columns: none; 
  }

  .mySwiper {
    max-width: 70vw;
    height: fit-content;
  }
}

@media (max-width: 550px) {
  .reviews .box-container {
    grid-template-columns: 1fr;
  }

  .main .fun-fact .card-contain {
    grid-template-columns: repeat(1, 1fr);
  }

  .main .articles {
    margin: 20px;
  }

  .mySwiper {
    height: 300px;
  }
  
  .map-section {
    height: 25vh;
  }
}

@media (max-width: 500px) {
  .next-btn {
    padding: .5rem 0;
  }

  .main .fitur .card {
    width: 100%;
  }

  .main .fitur .card .card-body p {
    text-align: center;
  }

  .main .main-recommended-articles {
    margin: 0;
  }

  .error-page {
    flex-flow: column-reverse;
  }

  .blog-card .text {
    width: 100%;
    grid-template-rows: 7fr 1fr;
  }

  .detail-recommended-articles .blog-card .text {
    grid-template-rows: 5fr 1fr;
  }

  .summary-card {
    grid-template-columns: none;
  }
}
`, "",{"version":3,"sources":["webpack://./src/styles/responsive.css"],"names":[],"mappings":"AAAA;EACE;IACE,cAAc;EAChB;;EAEA;IACE,eAAe;IACf,mBAAmB;IACnB,QAAQ;EACV;AACF;;AAEA;EACE;IACE,aAAa;EACf;;EAEA;IACE,UAAU;IACV,iBAAiB;EACnB;;EAEA;IACE,sBAAsB;IACtB,sBAAsB;IACtB,kBAAkB;IAClB,mBAAmB;IACnB,WAAW;IACX,YAAY;IACZ,aAAa;IACb,UAAU;IACV,yBAAyB;IACzB,YAAY;EACd;;EAEA;IACE,kBAAkB;IAClB,mBAAmB;EACrB;;EAEA;IACE,eAAe;IACf,gBAAgB;EAClB;AACF;;AAEA;AACA;;AAEA;EACE;IACE,kBAAkB;EACpB;;EAEA;IACE,WAAW;IACX,YAAY;EACd;AACF;;AAEA;EACE;IACE,aAAa;IACb,sBAAsB;IACtB,MAAM;EACR;;EAEA;;IAEE,WAAW;EACb;;EAEA;IACE,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;EACrB;;EAEA;IACE,gBAAgB;EAClB;AACF;;AAEA;EACE;IACE,kBAAkB;IAClB,8BAA8B;EAChC;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,aAAa;IACb,sBAAsB;IACtB,uBAAuB;IACvB,YAAY;EACd;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,QAAQ;IACR,eAAe;IACf,kBAAkB;EACpB;;EAEA;IACE,kCAAkC;IAClC,mBAAmB;IACnB,QAAQ;EACV;;EAEA;IACE,QAAQ;IACR,kBAAkB;IAClB,gBAAgB;EAClB;;EAEA;IACE,QAAQ;IACR,WAAW;EACb;;EAEA;IACE,WAAW;IACX,gBAAgB;IAChB,gBAAgB;EAClB;;EAEA;IACE,8BAA8B;EAChC;AACF;;AAEA;EACE;IACE,8BAA8B;EAChC;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,2BAA2B;EAC7B;;EAEA;IACE,wBAAwB;IACxB,qCAAqC;EACvC;;EAEA;IACE,qCAAqC;EACvC;;EAEA;IACE,YAAY;EACd;;EAEA;IACE,eAAe;EACjB;AACF;;AAEA;EACE;IACE,sBAAsB;EACxB;EACA;IACE,WAAW;IACX,mBAAmB;IACnB,sBAAsB;EACxB;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,0BAA0B;IAC1B,2BAA2B;EAC7B;;EAEA;IACE,2BAA2B;EAC7B;;EAEA;IACE,2BAA2B;EAC7B;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,WAAW;EACb;AACF;;AAEA;EACE;IACE,2BAA2B;EAC7B;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,2BAA2B;EAC7B;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;IACE,2BAA2B;EAC7B;;EAEA;IACE,eAAe;IACf,mBAAmB;EACrB;AACF;;AAEA;EACE;IACE,0BAA0B;EAC5B;;EAEA;IACE,qCAAqC;EACvC;;EAEA;IACE,YAAY;EACd;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,YAAY;EACd;AACF;;AAEA;EACE;IACE,gBAAgB;EAClB;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,SAAS;EACX;;EAEA;IACE,yBAAyB;EAC3B;;EAEA;IACE,WAAW;IACX,2BAA2B;EAC7B;;EAEA;IACE,2BAA2B;EAC7B;;EAEA;IACE,2BAA2B;EAC7B;AACF","sourcesContent":["@media (max-width: 1200px) {\n  .reviews .box-container {\n    margin: 0 auto;\n  }\n\n  .reviews .box-container .box .student h4 {\n    font-size: 15px;\n    padding-bottom: 1vh;\n    order: 1;\n  }\n}\n\n@media (max-width: 1100px) {\n  .app-bar__navigation {\n    z-index: 1000;\n  }\n\n  #indexOnMapContainer {\n    width: 35%;\n    font-size: 0.5rem;\n  }\n\n  .map-info {\n    flex-direction: column;\n    justify-content: start;\n    align-items: start;\n    border-radius: 10px;\n    right: 15px;\n    width: 145px;\n    padding: 1rem;\n    left: auto;\n    transform: translateX(0%);\n    bottom: 30px;\n  }\n\n  .index-info {\n    font-size: 0.75rem;\n    margin: 0 0 0.75rem;\n  }\n\n  .index-info .dot {\n    min-width: 10px;\n    min-height: 10px;\n  }\n}\n\n@media (min-width: 1135px) {\n}\n\n@media (max-width: 1020px) {\n  #detailContainer {\n    padding: 1rem 3rem;\n  }\n\n  .aqi-chart-card {\n    width: 100%;\n    height: 50vw;\n  }\n}\n\n@media (max-width: 1000px) {\n  .blog-article {\n    display: flex;\n    flex-direction: column;\n    gap: 0;\n  }\n\n  .article-content,\n  .blog-article .recommended-articles {\n    width: 100%;\n  }\n\n  .recommended-articles-container {\n    display: grid;\n    grid-template-columns: 1fr 1fr;\n    place-items: center;\n  }\n\n  .hero .image-hero img {\n    max-width: 250px;\n  }\n}\n\n@media (max-width: 950px) {\n  .main .hero {\n    text-align: center;\n    flex-direction: column-reverse;\n  }\n  \n  .main .section-title {\n    font-size: 32px;\n  }\n\n  .main .hero .content-hero {\n    display: flex;\n    flex-direction: column;\n    justify-content: center;\n    margin: auto;\n  }\n\n  .main .hero .content-hero p {\n    line-height: 100%;\n  }\n\n  .main .hero .content-hero p:nth-child(1) {\n    order: 2;\n    font-size: 16px;\n    padding-right: 0vw;\n  }\n\n  .main .hero .content-hero h2 {\n    font-size: clamp(32px, 6vw, 800px);\n    padding-bottom: 1vh;\n    order: 1;\n  }\n\n  .main .hero p:nth-child(3) {\n    order: 3;\n    padding-right: 0vw;\n    margin-top: 1rem;\n  }\n\n  .next-btn {\n    order: 4;\n    width: 100%;\n  }\n\n  .main .hero img {\n    width: 33vw;\n    min-width: 175px;\n    max-width: 300px;\n  }\n\n  .main .main-recommended-articles {\n    grid-template-columns: 1fr 1fr;\n  }\n}\n\n@media (max-width: 813px) {\n  .reviews .box-container {\n    grid-template-columns: 1fr 1fr;\n  }\n\n  .data-source {\n    width: 100%;\n  }\n\n  #detailContainer {\n    padding: 1rem;\n  }\n\n  .summary-section {\n    grid-template-columns: none;\n  }\n\n  .summary-side {\n    grid-template-rows: none;\n    grid-template-columns: repeat(2, 1fr);\n  }\n\n  .main .fun-fact .card-contain {\n    grid-template-columns: repeat(2, 1fr);\n  }\n\n  .map-section {\n    height: 100%;\n  }\n\n  .mySwiper {\n    max-width: 35vw;\n  }\n}\n\n@media (max-width: 700px) {\n  .charts {\n    flex-direction: column;\n  }\n  .aqi-chart-card {\n    width: 100%;\n    height: fit-content;\n    justify-content: start;\n  }\n\n  .recommended-articles-container {\n    grid-template-columns: 1fr;\n  }\n\n  .article-content img {\n    min-height: 150px;\n  }\n\n  .detail-recommended-articles .blog-card {\n    grid-template-columns: 1fr;\n    grid-template-rows: 1fr 1fr;\n  }\n\n  .detail-recommended-articles .blog-card .text {\n    grid-template-rows: 3fr 1fr;\n  }\n\n  .summary-section {\n    grid-template-columns: none;\n  }\n\n  .main .summary {\n    margin: auto 0.5em;\n  }\n\n  .main .main-recommended-articles {\n    margin: 1em;\n  }\n}\n\n@media (max-width: 660px) {\n  .rank-section {\n    grid-template-columns: none;\n  }\n\n  .blog-card {\n    width: 100%;\n  }\n\n  .blog-card .text {\n    grid-template-rows: 4fr 1fr;\n  } \n\n  .main .main-recommended-articles {\n    grid-template-columns: 1fr;\n  }\n\n  .summary-side {\n    grid-template-columns: none; \n  }\n\n  .mySwiper {\n    max-width: 70vw;\n    height: fit-content;\n  }\n}\n\n@media (max-width: 550px) {\n  .reviews .box-container {\n    grid-template-columns: 1fr;\n  }\n\n  .main .fun-fact .card-contain {\n    grid-template-columns: repeat(1, 1fr);\n  }\n\n  .main .articles {\n    margin: 20px;\n  }\n\n  .mySwiper {\n    height: 300px;\n  }\n  \n  .map-section {\n    height: 25vh;\n  }\n}\n\n@media (max-width: 500px) {\n  .next-btn {\n    padding: .5rem 0;\n  }\n\n  .main .fitur .card {\n    width: 100%;\n  }\n\n  .main .fitur .card .card-body p {\n    text-align: center;\n  }\n\n  .main .main-recommended-articles {\n    margin: 0;\n  }\n\n  .error-page {\n    flex-flow: column-reverse;\n  }\n\n  .blog-card .text {\n    width: 100%;\n    grid-template-rows: 7fr 1fr;\n  }\n\n  .detail-recommended-articles .blog-card .text {\n    grid-template-rows: 5fr 1fr;\n  }\n\n  .summary-card {\n    grid-template-columns: none;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
